<template>
    <div class="card" v-if="$canIf('groupcostintl.edit')">
        <form action="" method="post" @submit.prevent="editintCostGroup" id="intCostGroup-form">
            <div class="card-header">
                <div class="d-flex">
                    <h4>Editar Grupo</h4>
                </div>
            </div>
            <div class="card-body">
                <int-cost-group-form
                :errors="errors"
                :intCostGroup="intCostGroup"
                />
                
                <div class="col-12 mt-5">
                    <div class="card">
                        <div class="card-header">
                   <h5>Selecione Gateways/Troncos disponíveis <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="É necessário selecionar um  ou mais Gateways/Troncos para salvar ou editar as configurações  "></i></h5>
                           </div>                            
                    <div class="d-flex justify-content-center" id="form-trunks">
                        <div class="col-5">
                            <div class="card">
                                <div class="card-header">
                                    <h5>Disponíveis</h5>
                                </div>
                                <div class="card-body">
                                    <table class="table">
                                        <tbody class="caixa" id="not-bound-box">
                                            <tr v-for="tronco in allTrunks" :key="tronco.idTrunk" class="not-bounds" :id="tronco.idTrunk">
                                                <td>
                                                    <input type="checkbox" class="form-control not-bound-checkbox" :id="tronco.idTrunk+'_checkbox'">
                                                </td>
                                                <td>{{tronco.trunkName}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 d-flex flex-column align-self-center justify-content-center">
                            <div class="btn bg-brd btn-sm" @click="goRight">
                                <h5 class="m-0">
                                    <i class="fas fa-chevron-right text-white"></i>
                                </h5>
                            </div>
                            <br>
                            <div class="btn bg-brd btn-sm" @click="goLeft">
                                <h5 class="m-0">
                                    <i class="fas fa-chevron-left text-white"></i>
                                </h5>
                            </div>
                        </div>
                        <div class="col-5">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between">
                                    <h5>Utilizados</h5>
                                </div>
                                <div class="card-body pl-0 pr-0">
                                    <table class="table">
                                        <tbody class="caixa" id="bound-box">
                                            <tr v-for="tronco in trunks" :key="tronco.idTrunk" class="bounds trunks" :id="tronco.idTrunk">
                                                <td>
                                                    <input type="checkbox" class="form-control">
                                                </td>
                                                <td>{{tronco.trunkName}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <div class="card-footer">
                <button class="btn bg-success mr-2">Atualizar</button>
                <a @click="$router.go(-1)" class="btn bg-danger text-white">Voltar</a>
            </div>
        </form>
    </div>
</template>

<script>
import  IntCostGroupForm from "@/components/views/intCosts/Groups/_Form";
export default {

    components: {
        'int-cost-group-form': IntCostGroupForm,
    },

    props: [
        'group_id',
    ],

    created() {
        this.getAllTrunks();
    },

    updated() {
        var vinculados = document.querySelectorAll('.bounds');
        vinculados.forEach((tronco, index) => {
           tronco.querySelector('.prioridade').innerHTML = index + 1; 
        });
    },

    data(){
        return {
            errors: {},
            intCostGroup: {},
            trunks: [],
            allTrunks: [],
            idTrunks: [],
        }
    },

    methods: {
        editintCostGroup() {
            var dados = new FormData(document.getElementById('intCostGroup-form'));
            dados.append('_method', 'PUT');

            this.$httpApi.post('groupcostintl/'+this.group_id, dados, {
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                },
            }).then(() => {
                var trunks = document.querySelectorAll('.bounds');
                var update = [];
                trunks.forEach(tronco => {
                    update.push(tronco.getAttribute('id'));
                })
                this.$httpApi.post('groupcostintl/'+this.group_id+'/addTrunk', update, {
                    headers: {
                        'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                    },
                }).then(res => {
                    this.$router.push({ name: 'IntCostGroups.Index' })
                    this.$store.dispatch('criarMensagem',[
                        res.data.message,
                        'success'
                    ])
                })
            }).catch(res => {
                if(res.response.data.errors){
                    this.errors = res.response.data.errors
                }
                this.$store.dispatch('exibeErro', [
                    res.response
                ])
            })
        },

        getAllTrunks() {
            this.$httpApi.get('troncos/forGroupIntl/'+this.group_id,{
                headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                },
            }).then(res => {
                this.allTrunks = res.data.items;
                this.getTrunks();
            }).catch(res => {
                if(res.response.data.errors){
                    this.errors = res.response.data.errors
                }
                this.$store.dispatch('exibeErro', [
                    res.response
                ])
            });
        },

        getTrunks() {
            
            this.$httpApi.get('groupcostintl/'+this.group_id,{
                  headers: {
                    'Authorization': 'Bearer '+sessionStorage.getItem('Auth_Token'),
                },
            }).then(res => {
                this.intCostGroup = res.data.item;
                this.trunks = [];
                this.idTrunks = [];

                res.data.item.have_groups.forEach(tronco => {
                    this.idTrunks.push(tronco.trunk_id)
                });
                var intermed = [];
                this.allTrunks.forEach(tronco => {
                    if (this.idTrunks.includes(tronco.idTrunk)) {
                        this.trunks.push(tronco);
                    } else {
                        intermed.push(tronco);
                    }
                })
                this.allTrunks = intermed;
            }).catch(res => {
                if(res.response.data.errors){
                    this.errors = res.response.data.errors
                }
                this.$store.dispatch('exibeErro', [
                    res.response
                ])
            });
        },
        goRight() {
            var n_vinculados = document.querySelectorAll('.not-bounds');
            var mover = [];
            n_vinculados.forEach(item => {
                if (item.firstElementChild.firstElementChild.checked) {
                    this.allTrunks.forEach(tronco => {
                        if (tronco.idTrunk == item.getAttribute('id')) {
                            mover.push(tronco);
                        }
                    });
                }
            });
            mover.forEach(item => {
                const index = this.allTrunks.indexOf(item);
                if (index > -1) {
                    this.allTrunks.splice(index, 1);
                }
                this.trunks.push({
                    priority: this.trunks.length+1,
                    idTrunk: item.idTrunk,
                    trunkName: item.trunkName,
                })
            });
        },

        goLeft() {
            var vinculados = document.querySelectorAll('.bounds');
            var mover = [];
            vinculados.forEach(item => {
                if (item.firstElementChild.firstElementChild.checked) {
                    this.trunks.forEach(tronco => {
                        if (tronco.idTrunk == item.getAttribute('id')) {
                            mover.push(tronco);
                        }
                    });
                }
            });
            mover.forEach(item => {
                const position = this.trunks.indexOf(item);
                if (position > -1) {
                    this.trunks.splice(position, 1);
                }
                this.allTrunks.push({
                    idTrunk: item.idTrunk,
                    trunkName: item.trunkName,
                })
            });
        }
    },
}
</script>



<style>

</style>